
import { defineComponent } from "@vue/runtime-core";
export default defineComponent({
  name: "FrontTile",
  props: [
    "wiggle",
    "rowIndex",
    "row",
    "darkMode",
  ],
  components: {},
  setup(props) {
    const { rowIndex, row, darkMode } = props;
    
    return { rowIndex, row, darkMode,   };
  },
});
